export enum KodeKehadiranEnum {
  NONE = "-",
  HADIR = "H",
  MINGGU = "M",
  LIBUR = "L",
  IZIN = "I",
  SETENGAH_HARI = "S",
  CUTI = "C",
}
